import master from 'Modules/master'
import rollingTexts from 'Modules/rollingTexts'

//TODO
// Voir pour se débarasser de cette vue

master.process()
rollingTexts.initFooter()
